/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import 'jrs-ui/src/commons/commons.minimal.main';
import 'jrs-ui/src/namespace/namespace';
import 'jrs-ui/src/core/core.accessibility';
import 'jrs-ui/src/core/core.events.bis';
import 'jrs-ui/src/core/core.key.events';
import '../create/create.report';
import 'js-sdk/src/common/logging/logger';
import 'jrs-ui/src/resource/resource.base';
import 'jrs-ui/src/components/components.pickers';
import 'js-sdk/src/common/component/list/view/ListWithSelection';
import 'js-sdk/src/common/component/dialog/Dialog';
import 'js-sdk/src/common/component/dialog/AlertDialog';
import 'js-sdk/src/common/component/dialog/ConfirmationDialog';
import actionModel from 'jrs-ui/src/actionModel/actionModel.modelGenerator';
import primaryNavigation from '../actionModel/actionModel.primaryNavigation';
import globalSearch from 'jrs-ui/src/repository/repository.search.globalSearchBoxInit';
import layoutModule from 'jrs-ui/src/core/core.layout';
import jrsConfigs from 'js-sdk/src/jrs.configs';
import $ from 'jquery';

// add information about locale into body's class
$('body').addClass('locale-' + jrsConfigs.userLocale);
layoutModule.initialize();
// NOTE: Standard Navigation is initialized before these systems, in
// commons.minimal.main.js, for possible automation use, and to
// pre-empt these systems where appropriate.
primaryNavigation.initializeNavigation();    // global keyboard navigation setup
// menu setup
jrsConfigs.initAdditionalUIComponents && globalSearch.initialize();
//isNotNullORUndefined(window.accessibilityModule) && accessibilityModule.initialize();
//trigger protorype's dom onload manualy
document.fire('dom:loaded');
